import { render } from "./ProfileCardManagerProfileButton.vue?vue&type=template&id=0196a256&scoped=true"
import script from "./ProfileCardManagerProfileButton.vue?vue&type=script&lang=js"
export * from "./ProfileCardManagerProfileButton.vue?vue&type=script&lang=js"

import "./ProfileCardManagerProfileButton.vue?vue&type=style&index=0&id=0196a256&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0196a256"]])

export default __exports__